export default __webpack_public_path__ + "static/media/guardianspirit.0c651f43.png";